// extracted by mini-css-extract-plugin
module.exports = {"textInfo":"StaticsText_textInfo__TSN8F"};